import { render, staticRenderFns } from "./ProfileClient.vue?vue&type=template&id=5e5c1cde&scoped=true"
import script from "./ProfileClient.vue?vue&type=script&lang=js"
export * from "./ProfileClient.vue?vue&type=script&lang=js"
import style0 from "./ProfileClient.vue?vue&type=style&index=0&id=5e5c1cde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5c1cde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VIcon,VProgressCircular,VSwitch,VTab,VTabs})
